require('./style.less');

var Picker = require('vanilla-picker'); // ( the csp version )

module.exports = Picker;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/vendor/bundle/vanilla-picker/bundle.js
 ** module id = 334
 ** module chunks = 0
 **/